import { CloudWatchLogger } from './Logger';

const logger = new CloudWatchLogger();

export default logger;
